module.exports = __webpack_public_path__ + "static/media/ball_2_9.16924c15.mp3";